<template>
  <div id="InvenTory">
    <el-dialog
      title="提示"
      :visible.sync="visible"
      :show="show"
      append-to-body
      :close-on-click-modal="false"
      @close="closeDialog"
      width="500px"
    >
      <div class="InvenTory_box">
        <InputOne
          name="盘点仓库"
          icon1
          icon2
          isdisable
          v-model="Inventorys.FullName"
          field="Inventorys"
          @changeVal="changeVal"
          @clickAdd="clickAdd"
          @dblclick="clickSearch"
          @clickSearch="clickSearch"
          class="base_select"
          reg="empty"
          :error="serror"
        />
        <el-divider content-position="left">选择盘点类型</el-divider>
        <div>
          <p>
            <el-checkbox v-model="Drawplate" @change="Drawplatechange">抽盘</el-checkbox>
          </p>
          <label class="label">(抽取仓库中的部分商品进行盘点)</label>
          <p>
            <el-checkbox v-model="Overall" @change="Overallchange">全盘</el-checkbox>
          </p>
          <label class="label">(一次性盘点仓库中所有商品信息)</label>
        </div>
        <div v-if="Overall" class="Goodschange">
          <div class="Goodschange_box">
            <el-switch
              style="display: block"
              v-model="Goods"
              active-color="#409EFF"
              inactive-color="#ccc"
              @change="Goodschange"
            ></el-switch>
            <label class="label">{{goods}}</label>
          </div>
          <div class="Goodschange_box">
            <el-switch
              style="display: block"
              v-model="Stop"
              active-color="#409EFF"
              inactive-color="#ccc"
              @change="stopchange"
            ></el-switch>
            <label class="label">{{stop}}</label>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibl">确 定</el-button>
      </span>
    </el-dialog>
    <AddStorehouse :show.sync="addIfShow" />
    <Warehouse :show.sync="WarehouseIfShow" @dataname="dataname" :pargam="pargam" />
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
// import InputOne from "@/components/base/InputOne/InputOne.vue";
// import PurposeTable from "@/components/PurposeTable/PurposeTable/PurposeTable.vue";
// import AddStorehouse from "@/components/Addinput/AddStorehouse/AddStorehouse.vue";
// import Warehouse from "@/components/PurposeTable/Warehouse/Warehouse.vue";
export default {
  components: {
    // InputOne,
    // PurposeTable,
    // AddStorehouse,
    // Warehouse
  },
  data() {
    return {
      pargam: {
        Model: "TakeStock" //用于table配置项保存
      },
      visible: this.show,
      addIfShow: false,
      WarehouseIfShow: false,
      Inventorys: { FullName: "", KtypeId: Number("") }, // 选择仓库
      serror: "",
      dialogVisible: false,
      Drawplate: true,
      Overall: false,
      type: 0,
      Goods: false,
      Stop: false,
      stop: "显示停用数据",
      IsStop: 0,
      goods: "盘点有库存的商品",
      Additional: 0,
      InvId: 0,
      item: {
        append: "",
        title: "盘点单",
        component: "Inventory",
        menuId: "2-盘点单",
        query: {}
      }
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 全盘
    Drawplatechange(val) {
      if (val) {
        this.type = 0;
        this.Overall = false;
      }
      if (!val) {
        this.type = 1;
        this.Overall = true;
      }
    },
    // 部分
    Overallchange(val) {
      if (val) {
        this.type = 1;
        this.Drawplate = false;
      }
      if (!val) {
        this.type = 0;
        this.Drawplate = true;
      }
    },
    Goodschange(val) {
      if (val) {
        this.Additional = 1;
        // this.goods = "盘点有库存的商品";
      } else {
        this.Additional = 0;
        // this.goods = "盘点全部商品";
      }
    },
    stopchange(val) {
      if (val) {
        this.IsStop = 1;
        // this.stop = "显示停用数据";
      } else {
        this.IsStop = 0;
        // this.stop = "不显示停用数据";
      }
    },
    dataname(data) {
      this.Inventorys.FullName = data.FullName;
      this.Inventorys.KtypeId = data.KtypeId;
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
      this.Inventorys = { FullName: "", KtypeId: Number("") };
    },
    // 遍历权限
    ergodics(name) {
      let obj = [];
      let array = tool.getLocal("Button_Power");
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        obj.push(element);
        if (element.Name == name) {
          return obj[obj.length - 1];
        }
      }
    },
    // 遍历权限
    circulate(name, names) {
      let array = this.ergodics(names).List;
      let obj = [];
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        obj.push(element);
        if (element.Action == name) {
          return obj[obj.length - 1];
        }
      }
    },
    // 新增仓库
    clickAdd() {
      let array = this.circulate("新增", "仓库").Status;
      if (array) {
        this.addIfShow = true;
      } else {
        this.$message({
          showClose: true,
          message: "你没有操作权限",
          type: "warning"
        });
      }
    },
    // 选择仓库
    clickSearch() {
      this.WarehouseIfShow = true;
    },
    // 确定
    dialogVisibl() {
      if (this.Inventorys.FullName == "") {
        this.serror = "该值不能为空";
      } else if (this.Inventorys.FullName != "") {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          KtypeId: this.Inventorys.KtypeId,
          type: this.type,
          Additional: this.Additional,
          IsStop: this.IsStop
        };
        this.request
          .post("/index/Stock_Functions/InitTakeStock", {
            jparams: JSON.stringify(jparams)
          })
          .then(res => {
            if (res.status == 0) {
              this.visible = false;
              this.pathJumps(res.InvId);
            } else {
              this.$message({
                message: res.description,
                type: "warning"
              });
            }
          });

        this.serror = "";
      }
    },
    pathJumps(data) {
      this.item.menuId = this.item.menuId + "-1v";
      this.$tab.push(this.item, { vchCode: 0, InvId: data });
    },
    changeVal(data, text) {
      this[text].FullName = data;
      this.serror = "";
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  }
};
</script>

<style lang="less" >
.base_select {
  cursor: pointer !important;

  .el-input__inner {
    cursor: pointer !important;
  }
}
.InvenTory_box {
  height: 300px !important;
  p {
    margin-top: 15px;
  }
  .label {
    margin-left: 15px;
  }
  .Goodschange {
    margin-left: 15px;
    .Goodschange_box {
      margin-top: 15px;
      display: flex;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/InvenTory/InvenTory.vue